module.exports = __webpack_public_path__ + "img/bjhlwfy.66c4a0aa.png";